// import {Drawer} from "antd";
// import React, {useContext} from "react";
// import {DrawerContext} from "../context/drawercontext";
// import {HiArrowSmRight} from "react-icons/hi";
// import socialMedia from "../Data/SocialMedia";
//
// function ContactDrawer() {
//     const {open, onClose} = useContext(DrawerContext);
//
//     return (<Drawer
//             title={<div className="flex justify-between items-center">
//                 <h2 className="text-xl font-medium">Contact Us</h2>
//                 <button
//                     onClick={onClose}
//                     className="p-2 bg-gray-700 hover:bg-gray-800 text-white rounded-full transition-all duration-200"
//                 >
//                     <HiArrowSmRight className="text-2xl font-josefin"/>
//                 </button>
//             </div>}
//             closable={false}
//             onClose={onClose}
//             open={open}
//             width={500}
//             rootClassName="contact-drawer"
//         >
//             <div className="text-center space-y-4 p-3">
//                 {/* Google Maps Embed */}
//                 <div className="rounded-lg overflow-hidden shadow-md border border-gray-600 mb-8">
//                     <iframe
//                         src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d990.6338296977609!2d79.97059002936096!3d6.704323100000008!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae2491e249011d7%3A0x718f5400d09c85b6!2sSun%20Pledge%20Holdings%20(Pvt)%20Ltd!5e0!3m2!1sen!2slk!4v1741873065233!5m2!1sen!2slk"
//                         width="100%"
//                         height="300px"
//                         className="border-0"
//                         allowFullScreen=""
//                         loading="lazy"
//                         referrerPolicy="no-referrer-when-downgrade"
//                     ></iframe>
//                 </div>
//
//                 {/* Contact Details */}
//                 <div className="grid grid-cols-2 gap-4 text-sm text-gray-300">
//                     {/* Left Column: Phone & Email */}
//                     <div className="flex flex-col items-start space-y-2">
//                         <div className="text-start space-y-2">
//                             <h3 className="text-customyellow font-semibold">📞 Phone</h3>
//                             <p>+94 77 974 8015</p>
//                             <p>+94 38 761 0810</p>
//                         </div>
//
//                         <div className="text-start space-y-2">
//                             <h3 className="text-customyellow font-semibold mt-4">📧 Email</h3>
//                             <p>
//                                 <a
//                                     href="mailto:sunpledgeholdings@gmail.com"
//                                     className=" hover:underline"
//                                 >
//                                     sunpledgeholdings@gmail.com
//                                 </a>
//                             </p>
//                         </div>
//                     </div>
//
//                     {/* Right Column: Address */}
//                     <div className="flex flex-col items-start space-y-2">
//                         <div className="items-start space-y-2">
//                             <h3 className="text-customyellow font-semibold">
//                                 📍 Engineering Office
//                             </h3>
//                             <p className="text-left ps-12">
//                                 No.203B, Bolgoda, Horana Rd, Bandaragama
//                             </p>
//                         </div>
//                         <div className="items-start space-y-2">
//                             <h3 className="text-customyellow font-semibold mt-4">
//                                 📍 Marketing Office
//                             </h3>
//                             <p className="text-left ps-12">
//                                 No.372/1, Old Galle Rd, Gorakana, Panadura
//                             </p>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="flex space-x-3 justify-center">
//                     {socialMedia.map((social, index) => (<a
//                             key={index}
//                             href={social.href}
//                             target={'_blank'}
//                             className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-700 border border-gray-600 text-white hover:bg-yellow-400 hover:text-gray-900 hover:-translate-y-1 transition-all duration-300 hover:shadow-lg hover:shadow-yellow-400/20"
//                         >
//                             {social.icon}
//                         </a>))}
//                 </div>
//             </div>
//         </Drawer>);
// }
//
// export default ContactDrawer;
import {Drawer} from "antd";
import React, {useContext} from "react";
import {DrawerContext} from "../context/drawercontext";
import {HiArrowSmRight} from "react-icons/hi";
import socialMedia from "../Data/SocialMedia";
import {FaLocationDot, FaPhone} from "react-icons/fa6";

function ContactDrawer() {
    const {open, onClose} = useContext(DrawerContext);

    return (<Drawer
            title={<div className="flex justify-between items-center">
                <h2 className="text-xl font-semibold">Contact Us</h2>
                <button
                    onClick={onClose}
                    aria-label="Close Drawer"
                    className="p-2 bg-gray-700 hover:bg-gray-800 text-white rounded-full transition duration-200"
                >
                    <HiArrowSmRight className="text-2xl"/>
                </button>
            </div>}
            closable={false}
            onClose={onClose}
            open={open}
            width={500}
            rootClassName="contact-drawer"
        >
            <div className="text-center space-y-4 p-3">
                {/* Google Maps Embed */}
                <div className="rounded-lg overflow-hidden shadow-md border border-gray-600 mb-8">
                    <iframe
                        title="Sun Pledge office location"
                        src="https://www.google.com/maps?q=No.230%2C%20Horana%20Rd%2C%20Bolgoda%2C%20Bandaragama&output=embed"
                        width="100%"
                        height="300px"
                        className="border-0"
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>

                {/* Contact Section Title */}
                <h2 className="text-xl font-semibold relative pb-3 after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-10 after:h-1 after:bg-yellow-400">
                    Contact Us
                </h2>

                {/* Contact Details */}
                <ul className="space-y-4 font-semibold font-roboto">
                    <li className="flex justify-center text-gray-400">
                        <div className="flex flex-col space-y-2">
                            {[
                                {name: "Anupama Jayasekara", number: "+94 74 181 4164"},
                                {name: "Ravindu Rukmal", number: "+94 77 936 5857"},
                                {name: "Priyantha Jayasekara", number: "+94 77 974 8015"}
                            ].map((phone) => (
                                <a
                                    key={phone.number}
                                    href={`tel:${phone.number.replace(/ /g, '')}`}
                                    className="flex items-center text-gray-400 hover:text-white transition-all duration-300 hover:translate-x-1 relative after:content-[''] after:absolute after:w-0 after:h-px after:bg-yellow-400 after:left-0 after:bottom-0 after:transition-all hover:after:w-full"
                                >
                                    <FaPhone className="text-yellow-400 mr-2"/>
                                    <span>{phone.name}: {phone.number}</span>
                                </a>))}
                        </div>
                    </li>


                    <li className="flex items-center justify-center text-gray-400 space-x-2">
                        <FaLocationDot className="text-yellow-400"/>
                        <span>Address : No.230, Horana Rd, Bolgoda, Bandaragama</span>
                    </li>

                </ul>

                {/* Social Links */}
                <div className="flex space-x-3 justify-center pt-4 flex-wrap">
                    {socialMedia.map((social, index) => (<a
                            key={index}
                            href={social.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-700 border border-gray-600 text-white hover:bg-yellow-400 hover:text-gray-900 hover:-translate-y-1 transition-all duration-300 hover:shadow-lg hover:shadow-yellow-400/20"
                        >
                            {social.icon}
                        </a>))}
                </div>
            </div>

        </Drawer>);
}

export default ContactDrawer;
